import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { authApi } from "../../../entities/auth";

import { meApi } from "./me-api";
import { User, Company } from "./types";

interface MeState {
  user: User | null;
  isLoading: boolean;
  error: string | null;
  companies: Company[];
}

const initialState: MeState = {
  user: null,
  isLoading: false,
  error: null,
  companies: [],
};

const meSlice = createSlice({
  name: "me",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.error = null;
    },
    clearUser: (state) => {
      state.user = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(meApi.endpoints.getMyProfile.matchFulfilled, (state, action: PayloadAction<User>) => {
        state.user = action.payload;
        state.error = null;
        state.isLoading = false;
      })
      .addMatcher(authApi.endpoints.logout.matchFulfilled, (state) => {
        state.user = null;
        state.error = null;
        state.isLoading = false;
      })
      .addMatcher(authApi.endpoints.blockAccount.matchFulfilled, (state) => {
        state.user = null;
        state.error = null;
        state.isLoading = false;
      })
      .addMatcher(meApi.endpoints.getCompanies.matchFulfilled, (state, action) => {
        state.companies = action.payload.companies || [];
      });
  },
});

export const { setUser, clearUser, setLoading, setError } = meSlice.actions;
export default meSlice.reducer;
